import React from 'react';

import { PATH } from 'src/pages/pluginManagement';
import loadable from 'src/utils/loadable';
import { IRouter } from 'src/interfaces/route';
import { t } from 'src/libs/i18n';
import Layout from 'src/components/layout';
import { SCREENS } from 'src/constants/screens';

const PluginManagementPageRoute: IRouter[] = [
  {
    element: <Layout />,
    children: [
      {
        index: true,
        path: PATH,
        element: loadable(() => import('src/pages/pluginManagement')),
        title: t('master_registration.title'),
        screenId: SCREENS.R1513,
      },
    ],
  },
];

export default PluginManagementPageRoute;
